/* eslint-disable react/prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Creates a nice looking section title.
 *
 * **Usage**
 * ```
 * ddk.SectionTitle('Quarterly Earnings')
 * ```
 */
export default class SectionTitle extends Component {
    render() {
        const {id, children, className, style} = this.props;
        return (
            <div
                className={`section-title ${className || ''}`}
                id={id}
                style={style}
            >
                <div className="section-title--text">{children}</div>
                <div className="section-title--line" />
            </div>
        );
    }
}

SectionTitle.propTypes = {
    /**
     * The ID of this component, used to identify dash components
     * in callbacks. The ID needs to be unique across all of the
     * components in an app.
     */
    id: PropTypes.string,

    /**
     * The title of the SectionTitle
     */
    children: PropTypes.node,

    /**
     * The component's outermost className
     */
    className: PropTypes.string,

    /**
     * The component's outermost style
     */
    style: PropTypes.object,
};
